import React, { useMemo } from 'react';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { formatChartParamsDate } from '@/pages/opinion/components/ChartCommon/formatter';
import {
  reviewsFormat,
  yAxleFormat,
  getPercentage,
} from '@/pages/opinion/utils/value';
import { baseColors, extendColors } from '@/pages/opinion/constants';
import { useIntl } from 'umi';
import { formatTimeToShow } from '@op/utils/time';

interface chartInterFace {
  data: any;
  translate: (value: string) => string;
  height: number;
  filter: any;
  selected: string | null;
  eventsDict: any;
}

const colorArr = [...baseColors, ...extendColors];

export default ({
  height = 418,
  data,
  translate,
  filter,
  selected,
  eventsDict,
}: chartInterFace) => {
  const { formatMessage } = useIntl();

  // 设置图形配置
  const makeupOptions = () => { 
    let total = 0;
    const seriesData = data.map((item: { value: number; name: string }) => { 
      total += item.value; 
      return {
        ...item,
        value: item.value, 
        itemStyle: {
          color: colorArr[0],
          barBorderRadius: 2,
          ...(selected === item.name
            ? { borderWidth: 2, borderColor: '#262832' }
            : {}),
        },
      };
    });
    seriesData.sort(
      (a: { value: number }, b: { value: number }) => a.value - b.value,
    );
    const opts = {
      grid: {
        bottom: '0',
        right: '5%',
      },
      color: colorArr,
      tooltip: {
        formatter: (params: any) => {
          return formatChartParamsDate({
            total: total,
            title: formatTimeToShow(filter),
            params: params,
            listTitleFunc(item) {
              return translate(item.name);
            },
            dealwithRecords(records, total) {
              return records.map((item) => ({
                ...item,
                value: `${item.value}(${getPercentage(
                  item.originValue,
                  total,
                )})`,
              }));
            },
          });
        },
      },
      yAxis: {
        position: 'left',
        axisLabel: {
          show: true,
          margin: 24,
          interval: 0,
        },
        splitLine: {
          show: false,
          lineStyle: { color: '#E5E5E5', type: 'dashed' },
        },
        axisLine: {
          show: false,
        },
        type: 'category',
        axisTick: {
          show: false,
        },
        gridIndex: 0,
        data: [
          ...seriesData.map((item: { name: any }) => translate(item.name)),
        ],
      },
      xAxis: {
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: '#000000',
            opacity: '0.25',
          },
        },
        boundaryGap: true,
        type: 'value',
        splitLine: {
          show: true,
          lineStyle: { color: '#E5E5E5', type: 'dashed' },
        },
        axisLine: {
          show: true,
          lineStyle: { color: '#E5E5E5' },
        },
        axisLabel: {
          interval: 'auto',
          formatter: (value: number) => {
            return yAxleFormat(value);
          },
        },
      },
      series: [
        {
          name: 'rate',
          // barMaxWidth: 30,
          type: 'bar',
          data: seriesData,
          // selectedMode: !!eventsDict,
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            color: '#444',
            formatter: (params: { data: { value: any } }) => {
              return reviewsFormat(params?.data?.value);
            },
          },
        },
      ],
    };
    return opts;
  };

  const options = useMemo(() => {
    if (data.length === 0) {
      return {};
    }
    return makeupOptions();
  }, [data, formatMessage, selected]);

  return (
    <EChartCommon
      optionsProps={{ type: 'bar', excludeOptions: ['legend'] }}
      options={options}
      empty={data.length === 0}
      height={height}
      eventsDict={eventsDict}
    ></EChartCommon>
  );
};
